/* eslint-disable indent */
import angular from 'angular';
import uiRouter from 'angular-ui-router';

import orderAndPayDetailsComponent from './orderAndPay.component';

import Main from './main/main';
import PickupPoint from './pickupPoint/pickupPoint';


const orderAndPayDetailsModule = angular.module('tinaba.components.services.orderAndPay', [
    uiRouter,
    Main.name,
    PickupPoint.name,
])
.config(($stateProvider) => {
    'ngInject';
    $stateProvider.state('services.orderAndPay', {
        url: '/orderAndPay',
        template: '<order-and-pay-details></order-and-pay-details>',
        redirect: 'services.orderAndPay.main'
    });
})

.component('orderAndPayDetails', orderAndPayDetailsComponent);

export default orderAndPayDetailsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPay/orderAndPay.js
 **/